// Preço "a partir de" das atividades Civitatis: pontos com o apelido da campanha
// (campaignConfig.shortenCoinAlias) ou R$ quando a campanha desabilita pontos.
export const activityPriceInfo = (user) => ({
  showPoints: !user?.campaign?.disablePointActivity,
  shortenCoinAlias: user?.campaign?.campaignConfig?.shortenCoinAlias || "Pts",
});

// Retorna { amount, suffix } para que o card estilize o sufixo separadamente.
const formatActivityPrice = (activity, { showPoints, shortenCoinAlias }) => {
  const value = showPoints ? activity?.pointsPrice : activity?.price;
  if (value == null) return null;

  return showPoints
    ? { amount: Math.round(value).toLocaleString("pt-BR"), suffix: shortenCoinAlias }
    : {
        amount: `R$ ${Number(value).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        suffix: "",
      };
};

export default formatActivityPrice;
